module.exports = __webpack_public_path__ + "static/grbmember8-c4b3c1369c1a92b3ec06adf0080bd51f.jpg";